var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthiopia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0002C0 17.9574 0.352062 19.8322 0.99525 21.5656L16 22.9567L31.0047 21.5655C31.648 19.8322 32 17.9574 32 16.0002C32 14.0699 31.6581 12.2194 31.0316 10.5061L16 9.04369L0.968375 10.5062C0.341938 12.2194 0 14.0699 0 16.0002H0Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 32C22.8796 32 28.7443 27.658 31.005 21.5652H0.995361C3.25605 27.658 9.12074 32 16.0002 32Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 0C9.12074 0 3.25605 4.342 0.995361 10.4348H31.005C28.7443 4.342 22.8796 0 16.0002 0V0Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 23.6522C20.2258 23.6522 23.6518 20.2262 23.6518 16.0001C23.6518 11.7739 20.2258 8.34787 15.9996 8.34787C11.7734 8.34787 8.34741 11.7739 8.34741 16.0001C8.34741 20.2262 11.7734 23.6522 15.9996 23.6522Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9983 10.0745L17.3796 14.3259H21.8569L18.2333 16.9535L19.6256 21.2175L15.9983 18.5774L12.3765 21.2126L13.7631 16.9535L10.1428 14.3259H14.6169L15.9983 10.0745Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5078 17.0582L17.1256 15.6342L19.8339 11.9067L18.7084 11.0888L15.9999 14.8166L13.2917 11.0889L12.1661 11.9066L14.8744 15.6345L10.4923 17.0581L10.9222 18.3815L15.3044 16.9576V21.5653H16.6957V16.9576L21.0777 18.3815L21.5078 17.0582Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthiopia);
export default __webpack_public_path__ + "static/media/ethiopia.b491090c.svg";
export { ForwardRef as ReactComponent };